import { Controller } from "@hotwired/stimulus"
import { newrelicEnabled } from "helpers"

export default class extends Controller {
    static values = { user: String }

    connect() {
        if (newrelicEnabled()) {
            newrelic.setUserId(this.userValue);
        }
    }
}